import { Card } from '@/components/ui/card';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

interface ClientAcquisitionData {
  month: string;
  clients: number;
}

interface ClientAcquisitionChartProps {
  data: ClientAcquisitionData[];
}

export function ClientAcquisitionChart({ data }: ClientAcquisitionChartProps) {
  return (
    <Card className="p-6 border-gray-100 shadow-card">
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Client Acquisition</h3>
        <p className="text-sm text-gray-500 mt-1">New clients over time</p>
      </div>
      <div className="h-[300px]">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={data}>
            <defs>
              <linearGradient id="colorClients" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#4F46E5" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#4F46E5" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
            <XAxis
              dataKey="month"
              tick={{ fill: '#6B7280', fontSize: 12 }}
              tickLine={{ stroke: '#E5E7EB' }}
            />
            <YAxis
              tick={{ fill: '#6B7280', fontSize: 12 }}
              tickLine={{ stroke: '#E5E7EB' }}
              label={{ value: 'Clients', angle: -90, position: 'insideLeft', style: { fontSize: 12 } }}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: 'white',
                border: '1px solid #E5E7EB',
                borderRadius: '8px',
                boxShadow: '0 4px 12px 0 rgb(0 0 0 / 0.08)',
              }}
              formatter={(value: number) => [`${value} clients`, 'New Clients']}
            />
            <Area
              type="monotone"
              dataKey="clients"
              stroke="#4F46E5"
              strokeWidth={2}
              fillOpacity={1}
              fill="url(#colorClients)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
}
